import React from 'react';
import { connect } from 'react-redux';
import { arrayOf, object, string, bool } from 'prop-types';
import { NUMBER_STYLES, numberFormat } from '@fiverr-private/localization';
import { I18n } from '@fiverr-private/i18n-react';
import { getRecurringOptions } from '../../../reducers/packages';
import { getMaxDiscount, getMinDiscount } from '../../../utils/recurring';
import {
    getSubscriptionSubtitleKeySuffix,
    getSubscriptionTitleKeySuffix
} from '../../../utils/recurring/translation';
import BulletList from '../BulletList';

const SubscriptionInfoList = ({
    listClassName,
    titleClassName,
    recurringOptions,
    templates,
    showFullList = false
}) => {
    const maxDiscountPercentage = getMaxDiscount(recurringOptions);
    const minDiscountPercentage = getMinDiscount(recurringOptions);
    const hasDiscount = minDiscountPercentage > 0;
    const singleDiscount = minDiscountPercentage === maxDiscountPercentage;
    const subscriptionTitleSuffix = getSubscriptionTitleKeySuffix(hasDiscount);
    const subscriptionSubtitleSuffix = getSubscriptionSubtitleKeySuffix({ hasDiscount, singleDiscount });
    const subscriptionSubtitle = `gig_page_perseus.recurring.sidebar.subscription_payment.subtitle.${subscriptionSubtitleSuffix}`;
    const subtitleParams = {
        percentageMax: numberFormat((maxDiscountPercentage / 100), {
            style: NUMBER_STYLES.PERCENT
        }),
        percentageMin: numberFormat((minDiscountPercentage / 100), {
            style: NUMBER_STYLES.PERCENT
        })
    };

    const getI18nWithTemplate = (key) => (
        <I18n k={key} templates={templates}/>
    );

    const listItems = [
        getI18nWithTemplate(`gig_page_perseus.recurring.sidebar.subscription_payment.info_list.1.${subscriptionTitleSuffix}`),
        getI18nWithTemplate('gig_page_perseus.recurring.sidebar.subscription_payment.info_list.2'),
        getI18nWithTemplate('gig_page_perseus.recurring.sidebar.subscription_payment.info_list.3')
    ];
    if (showFullList) {
        listItems.push(getI18nWithTemplate('gig_page_perseus.recurring.sidebar.subscription_payment.info_list.4'));
    }

    return (
        <>
            <span className={titleClassName}>
                <I18n k={subscriptionSubtitle} params={subtitleParams}/>
            </span>
            <BulletList className={listClassName} listItems={listItems}/>
        </>
    );
};

SubscriptionInfoList.propTypes = {
    listClassName: string,
    titleClassName: string,
    recurringOptions: arrayOf(object),
    templates: object,
    showFullList: bool
};

const mapStateToProps = (state) => ({
    recurringOptions: getRecurringOptions(state.packages)
});

export { SubscriptionInfoList };
export default connect(mapStateToProps)(SubscriptionInfoList);
